// src/components/FormulaSlots.jsx
import { useState, useRef, useEffect } from "react";

function ItemSearch({ items, value, onChange, placeholder = "Search…" }) {
  const [query, setQuery] = useState("");
  const [open,  setOpen]  = useState(false);
  const ref = useRef(null);

  const selected = items.find(x => x.id === value);

  useEffect(() => {
    function handle(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  const filtered = items.filter(x =>
    !query ||
    x.id.toLowerCase().includes(query.toLowerCase()) ||
    x.name.toLowerCase().includes(query.toLowerCase())
  );

  if (selected) {
    return (
      <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
        <div className="form-input" style={{
          flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between",
          background: "#f0f9ff", cursor: "default", minWidth: 0
        }}>
          <span style={{ fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            <span style={{ fontWeight: 600, color: "#374151", marginRight: 5 }}>{selected.id}</span>
            <span style={{ color: "#6b7280" }}>{selected.name}</span>
          </span>
          <button
            style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 14, lineHeight: 1, padding: "0 0 0 6px", flexShrink: 0 }}
            onClick={() => { onChange(""); setQuery(""); }}>
            ×
          </button>
        </div>
      </div>
    );
  }

  return (
    <div ref={ref} style={{ position: "relative", flex: 1 }}>
      <input
        className="form-input"
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={query}
        autoComplete="off"
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
      />
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0, zIndex: 999,
          background: "#fff", border: "1px solid #d1d5db", borderRadius: 6,
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)", maxHeight: 220, overflowY: "auto"
        }}>
          {filtered.length === 0 ? (
            <div style={{ padding: "8px 12px", fontSize: 12, color: "#9ca3af" }}>No results</div>
          ) : (
            filtered.slice(0, 40).map(x => (
              <div key={x.id}
                style={{ padding: "7px 12px", cursor: "pointer", fontSize: 12, borderBottom: "1px solid #f3f4f6" }}
                onMouseDown={e => { e.preventDefault(); onChange(x.id); setQuery(""); setOpen(false); }}
                onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
                onMouseLeave={e => e.currentTarget.style.background = ""}>
                <span style={{ fontWeight: 600, color: "#1d4ed8" }}>{x.id}</span>
                <span style={{ color: "#6b7280", marginLeft: 6 }}>— {x.name}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export function FormulaSlots({ slots, setSlots, rms, sfgs, showType = false }) {
  const total = slots.reduce((s, f) => s + (parseFloat(f.qty) || 0), 0);
  const ok    = Math.abs(total - 100) < 0.1;
  const upd   = (i, k, v) => setSlots(s => s.map((x, j) => j === i ? { ...x, [k]: v } : x));

  return (
    <>
      {slots.map((sl, i) => {
        const items = showType && sl.type === "sfg" ? (sfgs || []) : (rms || []);
        const placeholder = showType && sl.type === "sfg" ? "Search SFG…" : "Search RM…";
        return (
          <div key={i} className="form-row" style={{ marginBottom: 7 }}>
            {showType && (
              <select className="form-select" style={{ width: 62 }} value={sl.type || "rm"}
                onChange={e => { upd(i, "type", e.target.value); upd(i, "id", ""); }}>
                <option value="rm">RM</option>
                <option value="sfg">SFG</option>
              </select>
            )}
            <ItemSearch
              items={items}
              value={sl.id || ""}
              onChange={v => upd(i, "id", v)}
              placeholder={placeholder}
            />
            <input className="form-input input-right" style={{ width: 80 }} type="number" step="0.01"
              min="0" max="100" placeholder="0.00" value={sl.qty}
              onChange={e => upd(i, "qty", e.target.value)} />
            <span style={{ fontSize: 13, color: "#6b7280", alignSelf: "center", marginLeft: 2 }}>%</span>
            <button className="btn-small" onClick={() => setSlots(s => s.filter((_, j) => j !== i))}>✕</button>
          </div>
        );
      })}
      <button className="btn" style={{ fontSize: 11, marginBottom: 10 }}
        onClick={() => setSlots(s => [...s, { id: "", type: showType ? "rm" : undefined, qty: "" }])}>
        + Add {showType ? "ingredient" : "RM"}
      </button>
      <div className={ok ? "alert-ok" : "alert-warn"} style={{ marginBottom: 12 }}>
        Batch total: {total.toFixed(2)}% {ok ? "✓ OK" : "— must = 100.00%"}
      </div>
    </>
  );
}
